<template>

  <popup-modal ref="popup">
    <v-card>
      <v-toolbar color="primary" dark>{{$t("dialogs.DialogChangePassword.toolbarTitle")}}</v-toolbar>

      <v-card-text class="mt-4">
        <v-form v-model="valid">
          <v-row>
            <v-col cols="12">
              <v-text-field
                  :append-icon="oldPasswShow ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="oldPasswShow ? 'text' : 'password'"
                  @click:append="oldPasswShow = !oldPasswShow"
                  prepend-icon="mdi-lock"
                  v-model="oldPassword"
                  :rules="[validRequired, validLength8chars]"
                  :label="$t('dialogs.DialogChangePassword.oldPasswordLabel')"
                  required
              ></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-text-field
                  :append-icon="newPasswShow1 ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="newPasswShow1 ? 'text' : 'password'"
                  @click:append="newPasswShow1 = !newPasswShow1"
                  prepend-icon="mdi-lock"

                  v-model="newPassword1"
                  :rules="[validRequired, validLength8chars]"
                  :label="$t('dialogs.DialogChangePassword.newPassword1Label')"
                  required
              ></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-text-field
                  :append-icon="newPasswShow2 ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="newPasswShow2 ? 'text' : 'password'"
                  @click:append="newPasswShow2 = !newPasswShow2"
                  prepend-icon="mdi-lock"

                  v-model="newPassword2"
                  :rules="[validRequired, validLength8chars, passwordMatch]"
                  :label="$t('dialogs.DialogChangePassword.newPassword2Label')"
                  required
              ></v-text-field>
            </v-col>

          </v-row>

        </v-form>
      </v-card-text>

      <!--                Actions-->
      <v-card-actions>
        <v-btn @click="Negative" text >{{$t("common.button_cancel")}}</v-btn>
        <v-btn :disabled="!valid" @click="Positive" color="primary">{{$t("common.button_save")}}</v-btn>
      </v-card-actions>

    </v-card>
  </popup-modal>

</template>


<script>
import PopupModal from "@/components/PopupModal";

export default {
  components: { PopupModal },
  data: () => ({
    valid: false,
    oldPassword: "",
    newPassword1:"",
    newPassword2:"",
    oldPasswShow:false,
    newPasswShow1:false,
    newPasswShow2:false,

    // Private variables
    resolvePromise: undefined,
    rejectPromise: undefined,
  }),
  methods:{

    validRequired(v) {
      return !!v || this.$t("dialogs.DialogChangePassword.validRequiredTitle")
    },

    validLength8chars(v) {
      return v.length >= 8 || this.$t("dialogs.DialogChangePassword.validLength8charsTitle")
    },
    passwordMatch(){
      return this.newPassword1 === this.newPassword2 || this.$t("dialogs.DialogChangePassword.validPasswordMatchTitle")
    },

    show(opts = {}) {
      console.log(opts)

      // Once we set our config, we tell the popup modal to open
      this.$refs.popup.open(false, true)

      // Return promise so the caller can get results
      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve
        this.rejectPromise = reject
      })
    },


    Positive(){
      this.$refs.popup.close()
      this.resolvePromise({answer: 'positive', oldPassword: this.oldPassword, newPassword: this.newPassword1})
    },
    Negative(){
      this.$refs.popup.close()
      this.resolvePromise({answer: 'negative'})
    },
  },
};
</script>
